/**
 * @flow
 * @relayHash a11fe7b3b6bdede0444ea4d300711cd0
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AiSettingsMutationVariables = {|
  enableAi: boolean
|};
export type AiSettingsMutationResponse = {|
  +setAiSettings: ?{|
    +ok: ?boolean
  |}
|};
export type AiSettingsMutation = {|
  variables: AiSettingsMutationVariables,
  response: AiSettingsMutationResponse,
|};
*/


/*
mutation AiSettingsMutation(
  $enableAi: Boolean!
) {
  setAiSettings(enableAi: $enableAi) {
    ok
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "enableAi",
    "type": "Boolean!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "setAiSettings",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "enableAi",
        "variableName": "enableAi",
        "type": "Boolean!"
      }
    ],
    "concreteType": "SetAiSettingsMutation",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "ok",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "AiSettingsMutation",
  "id": "fac33850f9a847fcb20483481d9ab50c",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "AiSettingsMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "AiSettingsMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
node.text = "mutation AiSettingsMutation(\n  $enableAi: Boolean!\n) {\n  setAiSettings(enableAi: $enableAi) {\n    ok\n  }\n}\n";
(node/*: any*/).hash = 'f9c54b2ac7cfc771efdf3e54f98835b3';
module.exports = node;
